import styled, {css} from 'styled-components'

export const StyledErrorMessage = styled.div(
    ({theme: {typography, colors}}) => css`
        ${typography.textXs};
        color: ${colors.red};
        font-weight: 400;
    `
)
